import { useSelector } from 'react-redux';
import { getIntegrationBySensorId } from 'state/selectors/sensors-authorizations';
import { SENSORS_MAP } from '@linearb/linjs-common';
import { SensorAuthorization } from 'types';

const useCopilotIntegration = (): SensorAuthorization | undefined => {
  const copilotIntegration: SensorAuthorization | undefined = useSelector(
    getIntegrationBySensorId(SENSORS_MAP.COPILOT)
  );
  return copilotIntegration;
};

export default useCopilotIntegration;
